import { BroadsignFrame, ILiveEntity, ILiveFrame, ILiveLinkedAsset } from 'types/detailsEntityType';
import { ISearchTableEntity } from 'types/tableEntityType';

const ENTITY_FIELDS_TO_SEARCH: Array<keyof ISearchTableEntity> = ['spaceId', 'name'];

const searchEntity = (
  entity: ILiveEntity,
  field:
    | 'mediaOwnerName'
    | 'status'
    | 'spaceId'
    | 'name'
    | 'environment'
    | 'formatSize'
    | 'entityType',
  searchTerm: string
) => entity[field]?.toString().toLowerCase().includes(searchTerm.toLowerCase());

const searchBroadsignFrames = (frame: ILiveFrame, searchTerm: string) =>
  frame.broadsignFrames?.map((bf: BroadsignFrame) => bf.broadsignFrameId).includes(searchTerm) ||
  frame.broadsignFrames?.map((bf: BroadsignFrame) => bf.displayUnitId).includes(searchTerm);

export const searchFrames = (searchTerm: string, frames: ILiveFrame[]): ILiveEntity[] => {
  return frames.filter((frame) => {
    return ENTITY_FIELDS_TO_SEARCH.some(
      (field) => searchEntity(frame, field, searchTerm) || searchBroadsignFrames(frame, searchTerm)
    );
  });
};

export const searchLinkedAssets = (
  searchTerm: string,
  linkedAssets: ILiveLinkedAsset[]
): ILiveEntity[] => {
  return linkedAssets.filter((linkedAsset) => {
    return ENTITY_FIELDS_TO_SEARCH.some((field) => searchEntity(linkedAsset, field, searchTerm));
  });
};
